module.exports = __webpack_public_path__ + "media/CGM1.9ee3afe7.mp4";